import { render, staticRenderFns } from "./WsInfoText.vue?vue&type=template&id=57b86d77&"
import script from "./WsInfoText.vue?vue&type=script&lang=js&"
export * from "./WsInfoText.vue?vue&type=script&lang=js&"
import style0 from "./WsInfoText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports